<button
  appButton
  name="back"
  [location]="location()"
  [iconButton]="true"
  color="simple-gray-50"
  (click)="back.emit()"
  height="0"
>
  <app-svg src="/assets/icons/arrow-left.svg"></app-svg>
</button>
<h1>{{ title() }}</h1>
